export default [
  {
    path: '/Inspection',
    name: 'Inspection',
    redirect: '/Inspection/home',
    component: () => import('@/views/Inspection/index.vue'),
    meta: {
      type: 'Inspection',
      keepAlive: true,
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/Inspection/home.vue'),
      },
      {
        path: 'need',
        name: 'InspectionNeed',
        component: () => import('@/components/common/Need'),
      },
      {
        path: 'need-details',
        name: 'InspectionNeedDetails',
        component: () => import('@/components/common/NeedDetails'),
      },
      {
        path: 'ServicePublish',
        name: 'InspectionServicePublish',
        component: () => import('@/components/common/NeedDetails'),
      },
      {
        path: 'service-provider-info',
        name: 'InspectionServiceDetails',
        component: () => import('@/components/common/ServiceDetails'),
      },
      {
        path: 'institutions',
        name: 'InspectionInstitutions',
        component: () => import('@/components/common/Institutions'),
      },
      {
        path: 'search-detail',
        name: 'InspectionSearchDetail',
        component: () => import('@/components/common/SearchDetail'),
      },
      {
        path: 'help',
        name: 'InspectionHelp',
        component: () => import('@/components/common/Help'),
      },
      {
        path: 'about',
        name: 'InspectionAbout',
        component: () => import('@/components/common/About'),
      },
      {
        path: 'traceability',
        name: 'InspectionTraceability',
        component: () => import('@/components/common/Traceability'),
        children: [
          {
            path: 'articlen-information',
            redirect: '/Inspection/articlen-information',
          },
        ],
      },
      {
        path: 'articlen-information',
        name: 'InspectionArticleDetails',
        component: () => import('@/components/common/Traceability/Details'),
      },
      {
        path: 'Standard',
        name: 'Standard',
        component: () => import('../views/CenterMain/Standard.vue'),
      },
    ],
  },
]
